import React from 'react'
import Wrapper, { IIconProps } from './Wrapper'

export default (props: IIconProps) => {
  return (
    <Wrapper {...props}>
      <svg
        viewBox='0 0 24 24'
        width='1em'
        height='1em'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g fill='none' fillRule='evenodd'>
          <path
            d='m19 13h-6v6h-2v-6h-6v-2h6v-6h2v6h6z'
            fill='currentColor'
            fillRule='nonzero'
          />
          <path d='m0 0h24v24h-24z' />
        </g>
      </svg>
    </Wrapper>
  )
}
